import React from "react";
import "./hero.scss";
import "../../../../utils/Styles/globalclasses.scss";


const Hero = ({ text, date }) => {
  return (
    <div className="heroTerms__section">
      <div className="heroTerms__section__wrapper">
        <h1 className="heroTerms__section__wrapper__heading primary__heading">
            {text}
        </h1>
        <p>{date}</p>

      </div>
    </div>
  );
};

export default Hero;
